/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_SubtitleInputs */

const en_directory_home_hero_subtitle = /** @type {(inputs: Directory_Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every tool independently scored on six dimensions, price-checked weekly, and compared against the alternatives.`)
};

const zh_directory_home_hero_subtitle = /** @type {(inputs: Directory_Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个工具独立六维评分、每周核实价格、逐一对比替代方案。`)
};

/**
* | output |
* | --- |
* | "Every tool independently scored on six dimensions, price-checked weekly, and compared against the alternatives." |
*
* @param {Directory_Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_subtitle = /** @type {((inputs?: Directory_Home_Hero_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_subtitle(inputs)
	return zh_directory_home_hero_subtitle(inputs)
});
export { directory_home_hero_subtitle as "directory.home.hero.subtitle" }